var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.drawer,
            size: "600px",
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "form-center",
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    "label-width": "120px",
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "备件编号", prop: "Code" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入备件编号" },
                        model: {
                          value: _vm.form.Code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备件名称", prop: "Name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入备件名称" },
                        model: {
                          value: _vm.form.Name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Name", $$v)
                          },
                          expression: "form.Name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备件规格", prop: "Spec" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入备件规格" },
                        model: {
                          value: _vm.form.Spec,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Spec", $$v)
                          },
                          expression: "form.Spec",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备件类型", prop: "MaterialTypeId" } },
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          filterable: "",
                          options: _vm.OptionsTree,
                          props: {
                            emitPath: false,
                            expandTrigger: "hover",
                            checkStrictly: true,
                            children: "children",
                            label: "title",
                            value: "Id",
                          },
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.MaterialTypeId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "MaterialTypeId", $$v)
                          },
                          expression: "form.MaterialTypeId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "单位", prop: "storageName" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "calc(100% - 60px)" },
                            attrs: {
                              placeholder: "请选择单位组",
                              disabled: "",
                            },
                            model: {
                              value: _vm.form.storageName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "storageName", $$v)
                              },
                              expression: "form.storageName",
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "60px" },
                              attrs: { type: "primary" },
                              on: { click: _vm.openMeasuringunit },
                            },
                            [_c("i", { staticClass: "el-icon-search" })]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "厂家", prop: "Manufacturer" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入厂家名称" },
                        model: {
                          value: _vm.form.Manufacturer,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Manufacturer", $$v)
                          },
                          expression: "form.Manufacturer",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "Remarks" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "",
                          type: "textarea",
                          rows: "3",
                          resize: "none",
                        },
                        model: {
                          value: _vm.form.Remarks,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Remarks", $$v)
                          },
                          expression: "form.Remarks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("Measuringunit", {
        ref: "Measuringunit",
        attrs: { type: "radio" },
        on: { select: _vm.handleUnit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }